export default "__VITE_ASSET__COWgC836__"